import { styled } from '@linaria/react';
import { colors, fonts } from '../../../theme/tokens';

export const Cell = styled.button`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 1;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 2px;
  font-family: ${fonts.body};
  border-radius: 50%;
  transition: background-color 0.15s ease;

  &[data-empty] {
    cursor: default;
    pointer-events: none;
  }

  &[data-blocked] {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.35;
  }

  &[data-check-in-closed] {
    background: ${colors.lighterGrey};
  }

  &[data-in-range] {
    background: ${colors.tertiary}33;
    border-radius: 0;
  }

  &[data-selected] {
    background: ${colors.primary};
    color: ${colors.white};
  }

  &[data-hoverable]:hover {
    background: ${colors.tertiary}66;
  }
`;

export const DayNumber = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.medium};
  line-height: 1.2;
  color: ${(p) => (p.$selected ? colors.white : colors.fontPrimary)};
`;

export const DayPrice = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.xxs};
  line-height: 1;
  color: ${(p) => (p.$selected ? colors.white : colors.fontSecondary)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;
